// extracted by mini-css-extract-plugin
export default {"wrap":"UlForMenu_wrap__Qqa9+","menuItem":"UlForMenu_menuItem__D5LLV","icon":"UlForMenu_icon__zGnIP","menuText":"UlForMenu_menuText__D1YNF","active":"UlForMenu_active__qBIqD"};